<template>
  <div class="text-center mt-4">
    <button v-if="!showButton" class="btn btn-success btn-sm" disabled>
      <i class="fas fa-check mr-1" style="font-size: 0.8rem"></i>
      Saved
    </button>

    <b-overlay
      :show="loaderOverlayShowing"
      rounded
      opacity="0.2"
      spinner-small
      spinner-variant="white"
      class="d-inline-block"
    >
      <button
        v-if="showButton"
        @click="handleButtonClick"
        type="button"
        class="btn btn-sm btn-submit"
        :disabled="disabled"
      >
        {{ buttonText }}
      </button>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'FormSaveButton',
  // formSection: Name of form section
  // showDefault: show the initial state of the 'Save' button
  //done: once save op is started, flag to signalling when it's finished
  //   props: ['formSection', 'showDefault', 'done'],
  props: {
    formSection: String,
    // showDefault: {
    //   type: Boolean,
    //   default: true,
    // },

    disabled: {
      type: Boolean,
      default: false,
    },

    // Set to true when save op is underway and it ends
    done: {
      type: Boolean,
      default: false,
    },
    // Signals that button is to be reset
    resets: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      buttonClicked: false,
      buttonText: 'Save',
    };
  },
  watch: {
    resets: function () {
      //   if (newVal !== oldVal) {
      //     console.log('watch', newVal, oldVal);
      //     this.resetButton();
      //   }
      this.resetButton();
    },
  },
  computed: {
    readyToSave: function () {
      return !this.buttonClicked & !this.done && this.buttonText === 'Save';
    },
    savingStarted: function () {
      return this.buttonClicked && !this.done;
    },
    savingFinished: function () {
      return this.buttonClicked && this.done;
    },

    showButton: function () {
      return this.readyToSave || this.savingStarted;
    },
    //    showButton: function () {
    //       if (this.buttonClicked) {
    //         return this.done ? false : true;
    //       }
    //       //   return true;
    //       return this.showDefault;
    //     },
    loaderOverlayShowing: function () {
      return this.savingStarted && !this.savingFinished;
      //   if (this.buttonClicked) {
      //     return this.done ? false : true;
      //   }
      //   return false;
    },
  },
  methods: {
    resetButton: function () {
      this.buttonClicked = false;
      this.buttonText = 'Save';
    },
    handleButtonClick: function () {
      this.buttonClicked = true;
      this.buttonText = 'Saving';
      this.$emit('click', this.formSection);
    },
  },
};
</script>

<style>
</style>